import { useMutation } from '@apollo/client'
import { POST_PROPERTY_DISCLOSURE_FORM } from './property-disclosure'

export const usePostPropertyDisclosureForm = () => {
  const query = useMutation(POST_PROPERTY_DISCLOSURE_FORM, {
    fetchPolicy: 'no-cache',
    context: { clientName: typeof window !== 'undefined' ? 'proxy' : null },
  })
  return query
}
